import {Component} from 'react';
import axios from 'axios';
import Navbar from './Navbar';

export default class Connect extends Component {
    constructor(){
        super()
        this.state = {
            name: "",
            email: "",
            message: ""
        }
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangeMessage = this.handleChangeMessage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChangeName(event){
        this.setState({
            name: event.target.value
        })
    }
    handleChangeEmail(event){
        this.setState({
            email: event.target.value
        })
    }
    handleChangeMessage(event){
        this.setState({
            message: event.target.value
        })
    }
    // console.log(axios.post('/api/connect/', {"name": "lll", "email": "lll", "message": "lll"})
    handleSubmit(event){
        event.preventDefault()
        console.log(this.state, "state")
        axios.post('/api/connect/', {"name": this.state.name, "email": this.state.email, "message": this.state.message})
        .then(res => {
            console.log(res)
        })
        document.getElementById("reset").requestFullscreen();
        this.setState({
            name: "",
            email: "",
            message: ""
        })
    }
    render(){
        return(
            <div>
                <Navbar />
                <div className="content">
                    <h2 className="subtitle">Connect with me :</h2>
                    <div className='form'>
                        <form className="form connect" id="reset" onSubmit={this.handleSubmit}>
                            <label className="label"> Name      :      </label>
                            <input className='input'onChange={this.handleChangeName} />
                            <label className="label"> Email      :      </label>
                            <input className='input'onChange={this.handleChangeEmail} />
                            <label className="label1"> Message      :      </label>
                            <input className='input1'onChange={this.handleChangeMessage} />
                            <button className='button3' type="submit"> Submit </button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}